import { Filter, FilterProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';

type SearchListFilterProps = Omit<FilterProps, 'items'>;

export const SearchListFilter = ({ ...props }: SearchListFilterProps) => {
  const { t } = useTranslation();

  return (
    <Filter
      {...props}
      searchInputProps={{
        placeholder: t('common.search.placeholder'),
        ...props?.searchInputProps,
      }}
    />
  );
};
